// extracted by mini-css-extract-plugin
export default {"transparent_box":"BoxTransparent_transparent_box__Zo1kv"};